export default __webpack_public_path__ + "static/media/files-circle-white-tc.a23e200a.svg";